

<div class="flex align-items-center column-gap-2 cursor-pointer" #trigger cdkOverlayOrigin (click)="toggleMenu()">
    <div class=" notification-icon-container p-1" style="margin-top: -3px" >
        <mat-icon style="vertical-align: middle; color: #B1B1B1" > person </mat-icon>
    </div>
    <div class="font-medium">Hi, {{ user }}</div>
    <i class="pi pi-chevron-down text-sm menu-icon" [class.open]="displayMenu"></i>
</div>



<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="displayMenu = false"
  backdropClass="transparent-backdrop"
  [cdkConnectedOverlayOpen]="displayMenu"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayPush]="true">
  <div class="menu-container rounded flex flex-column">
    <div class="menu-item flex flex-row align-items-center column-gap-2 cursor-pointer px-3 py-2" (click)="goTo('profile')">
        <i class="pi pi-user" ></i>
        <span>Profile</span>
    </div>
    <div class="menu-item flex flex-row align-items-center column-gap-2 cursor-pointer px-3 py-2" (click)="goTo('password')">
        <i class="pi pi-lock" ></i>
        <span>Change Password</span>
    </div>
    <div class="menu-item flex flex-row align-items-center column-gap-2 cursor-pointer px-3 py-2" (click)="goTo('logout')">
        <i class="pi pi-sign-out" ></i>
        <span>Log Out</span>
    </div>
  </div>
</ng-template>